export const AuthTypes = {
  LOGIN_SUCCESS: "AUTH::LOGIN_SUCCESS",
  LOGOUT: "AUTH::LOGOUT",
  PREF: "AUTH::PREF",
  SET_USER_PREF: "AUTH::SET_USER_PREF"
};
